import Slider from '@mui/material/Slider';
import { styled } from '@mui/system';
import colors from '../../assets/colors';

const GreenSlider = styled(Slider)({
  '&.MuiSlider-root': {
    color: colors.agroweGreen,
    height: 8,
  },
  '&.MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: colors.oldAgroweGreen,
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: 'inherit',
    },
  },
  '&.MuiSlider-active': {},
  '&.MuiSlider-valueLabel': {
    left: 'calc(-50% + 4px)',
  },
  '&.MuiSlider-track': {
    height: 8,
    borderRadius: 4,
  },
  '&.MuiSlider-rail': {
    height: 8,
    borderRadius: 4,
  },
});

export default GreenSlider;
